/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// actions and reducers used to manipulate application state

// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Account from 'pages/dashboard/account/account';



/* ========== ~~~~~~~~~~ ACCOUNT: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    generalPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.general'),
    adsTxtPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.adsTxt'),
    paymentInfoPermitted: sessionStatus.permissions.includes('settings.paymentInfo'),
    agreementPermitted: !sessionStatus.mocked && sessionStatus.permissions.includes('settings.agreement'),
    sitesPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.sites') || sessionStatus.permissions.includes('setttings.sites'),
    usersPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.users'),
    permissions: sessionStatus.permissions
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default withRouter(connect(
    mapStateToProps,
)(Account));